<template>
    <span class='container' @click="$emit('click')">
        <b-icon
            :icon="this.determinedIcon"
            size="is-small">
        </b-icon>
        <span>{{ this.text || 'Edit' }}</span>
    </span>
</template>

<style scoped>
span.container {
    border: 1px dashed #888;
    border-radius: 6px;
    padding: 2px 6px;
    font-size: 14px;
    font-weight: normal;
    cursor: pointer;
}
span.container:hover {
    border-color: #555;
    background-color: #f1f1f1;
}
</style>

<script>
export default {
  name: 'EditLink',
  props: ['icon', 'text'],
  data () { return {} },
  computed: {
    determinedIcon() {
      return this.$props.icon || 'pencil'
    }
  },
  mounted: function() {}
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/EditLink.vue